import { Box, LinkText } from "@bcc-ui/ui-components";
import React from "react";

import style from "./link-text-box.scss";

interface Props {
    children: string | React.ReactNode;
    onClick: () => void;
    icon?: React.ReactNode;
}

export const LinkTextBox = (props: Props) => {
    return (
        <Box className={style.container} verticalAlignment={"Center"} gap={"Xxs"}>
            {props.icon}
            <LinkText as={"button"} onClick={props.onClick}>
                {props.children}
            </LinkText>
        </Box>
    );
};
